import EpgPersistence from "../../../AAF/Nepg/EpgPersistence";
import AbstractRequestTask from "../AbstractRequestTask";
import { DOMAIN } from "./const";

class matchesTask extends AbstractRequestTask{
    constructor(leagueId, matchId, view = 'all', acceptLanguage = "es-ES" , version = 'v1') {
        super();
        this.leagueId = leagueId;
        this.matchId = matchId;
        this.view = view;
        this.acceptLanguage = acceptLanguage;
        this.version = version;
        this.params = super.getParams();
        this.user_token = this.params.user_token;
    }

    getUrl() {
        const http = "https://";
        const domain = DOMAIN;
        const path = `/services/sports/${this.version}/competitions/${this.leagueId}/matches/${this.matchId}`;
                      
        return `${http}${domain}${path}`;
    }

    getParams() {
        const params = super.getParams();
        params.view = this.view;
        delete params.format
        delete params.api_version
        delete params.user_token

        return {
            ...params,
            timezoneOffset: EpgPersistence.getOffset() / 60
        };
    }

    getHeaders() {
        return {
            'Authorization': `Bearer ${this.user_token}`,
            'Accept-Language': this.acceptLanguage
        }
    }

    getMethod() {
        return 'GET';
    }
}

export default matchesTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/sports/matchesTask.js